// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"76a9bc18","171":"4c31e43b","484":"405e6c1e","494":"26ab82f5","616":"47fd953e","653":"e66656e5","845":"0ac59a8f","874":"7b108644"}[chunkId] + ".chunk.js";
};